import React from "react";

export const BoxContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>((props, ref) => {
  const { className, ...rest } = props;
  const shouldApplyPadding = !className?.includes('px-0');
  return (
    <div
      ref={ref}
      className={`${shouldApplyPadding ? 'px-8' : ''} min-h-[calc(100vh-17rem)] flex flex-col flex-1 ${
        className ? className : ""
      }`}
      {...rest}
    >
      {props.children}
    </div>
  );
});
